import { getSupabaseBrowserClient } from './supabase';
import { deleteDecksImages, deleteOriginalFile } from './imageStorage';
export type LibraryFolder = {id:string;name:string};
export type LibraryJob = {id:string;file_name:string;status:string;stage:string;folder_id:string|null;pending:number;accepted:number;accepted_goal:number;created_at:string};
function client() { const value=getSupabaseBrowserClient(); if(!value)throw Error('Library is unavailable.'); return value; }
export async function libraryRpc<T>(name:string,input:Record<string,unknown>={}):Promise<T> {
  const {data,error}=await client().rpc(name,input); if(error)throw Error(error.message); return data as T;
}
export async function listLibraryFolders():Promise<LibraryFolder[]> {
  const {data,error}=await client().from('library_folders').select('id,name').order('name').limit(200);
  if(error)throw Error('Could not load folders.');return data || [];
}
export function moveLibraryItem(folder:string, item:{deck?:string;job?:string}) {
  return libraryRpc('manage_library_folder',{p_action:'move',p_folder:folder || null,p_deck:item.deck || null,p_job:item.job || null});
}
export async function deleteLibraryFolder(folder: string, deleteDecks: boolean) {
  const result = await libraryRpc<{id:string;user_id:string;deleted_deck_ids:string[]}>('delete_library_folder', {p_folder:folder,p_delete_decks:deleteDecks});
  await cleanupDeletedDecks(result);
  return result;
}
export async function bulkLibraryDecks(action:'move'|'delete',ids:string[],folder:string='') {
  const result=await libraryRpc<{user_id:string;deck_ids:string[];deleted_deck_ids:string[]}>('bulk_library_decks',{p_action:action,p_decks:ids,p_folder:action==='move'?(folder||null):null});
  await cleanupDeletedDecks(result);
  return result;
}
async function cleanupDeletedDecks(result:{user_id:string;deleted_deck_ids:string[]}) {
  // As with single-deck deletion, clean files only after the protected DB delete.
  // Bound concurrency and use only IDs actually deleted by the server.
  for (let offset=0;offset<result.deleted_deck_ids.length;offset+=4) {
    const cleanup = await Promise.allSettled(result.deleted_deck_ids.slice(offset,offset+4).flatMap(id=>[
      deleteDecksImages(result.user_id,id),deleteOriginalFile(result.user_id,id),
    ]));
    if(cleanup.some(item=>item.status==='rejected')) console.error('[Library] Some deleted-deck files could not be cleaned up.');
  }
}
